import bact from '@/sui/data/sheets/edit/bact'
import bounds from '@/sui/data/sheets/edit/bounds'
import patient from '@/sui/data/sheets/edit/patient'
import notes from '@/sui/data/sheets/edit/notes'
import fields from '@/sui/data/sheets/edit/fields'

import common from '@/sui/data/sheets/edit/notes/common'

function checkNumericValues (result, sheet) {
  const numericChecks = [
    bounds.gestationalAge,
    bounds.birthWeight
  ]

  notes.checkNumerics(result, sheet, numericChecks)
}

function checkBacteremia (result, sheet) {
  const type = sheet[fields.unitType]
  const neoPedMix = type != null && type.match(/^(NEO|MIX|PED)/) != null
  common.checkBactOrigin(result, sheet, neoPedMix)
}

function checkDates (result, sheet, year) {
  const birthdate = notes.dateField(result, sheet, patient.birthdate)
  const entrydate = notes.dateField(result, sheet, patient.entrydate)
  const episod = notes.dateField(result, sheet, bact.episod)

  if (year >= 2025) {
    common.checkEpisodAndEntry(episod, entrydate)
  }

  const dateVersion = year === 2019 ? 'v1' : 'v2'
  const insertionDate = notes.dateField(
    result, sheet, bact.insertionDate[dateVersion]
  )
  const enfInsertionDate = notes.dateField(
    result, sheet, bact.enfInsertionDate[dateVersion]
  )
  const removalDate = notes.dateField(
    result, sheet, bact.removalDate[dateVersion]
  )

  const death = notes.dateField(result, sheet, patient.deathDate)
  const oldest = notes.oldest[`${year}`]
  const newest = notes.newest[`${year}`]
  const start = notes.start[`${year}`]

  const comparisons = [
    { f: oldest, s: birthdate },
    { f: birthdate, s: entrydate },
    { f: entrydate, s: death },
    { f: entrydate, s: newest },

    { f: birthdate, s: episod },
    { f: start, s: episod },
    { f: episod, s: newest },
    { f: episod, s: death },

    { f: birthdate, s: insertionDate },
    { f: insertionDate, s: episod },
    { f: insertionDate, s: death },
    { f: insertionDate, s: newest },
    { f: insertionDate, s: removalDate },

    { f: birthdate, s: removalDate },
    { f: removalDate, s: newest },
    { f: removalDate, s: death },

    { f: birthdate, s: enfInsertionDate },
    { f: enfInsertionDate, s: newest },
    { f: enfInsertionDate, s: death },
    { f: enfInsertionDate, s: episod },

    { f: birthdate, s: death },
    { f: death, s: newest }
  ]

  if (year === 2019) {
    notes.compareDates(comparisons)
    return
  }

  const diagdate = notes.dateField(result, sheet, bact.diagDate.v1)
  const urinaryStart = notes.dateField(result, sheet, bact.urinaryStart.v1.std)
  const urinaryEnd = notes.dateField(result, sheet, bact.urinaryEnd.v1.std)
  comparisons.push(
    { f: birthdate, s: urinaryStart },
    { f: urinaryStart, s: episod },
    { f: urinaryStart, s: urinaryEnd },
    { f: urinaryEnd, s: death },
    { f: urinaryEnd, s: newest },

    { f: episod, s: diagdate },
    { f: birthdate, s: diagdate }
  )

  if (year >= 2021) {
    const manipdate = notes.dateField(result, sheet, bact.previousManipDate)
    const enfmanipdate = notes.dateField(
      result, sheet, bact.enfPreviousManipDate
    )

    const beforeEpisod = common.beforeEpisod(
      episod.date, result[bact.episod.field]
    )
    const intubStart = notes.dateField(result, sheet, bact.intubStart)
    const intubEnd = notes.dateField(result, sheet, bact.intubEnd)

    comparisons.push(
      { f: birthdate, s: manipdate },
      { f: beforeEpisod, s: manipdate },
      { f: manipdate, s: episod },
      { f: insertionDate, s: manipdate },
      { f: manipdate, s: removalDate },
      { f: manipdate, s: death },

      { f: birthdate, s: enfmanipdate },
      { f: beforeEpisod, s: enfmanipdate },
      { f: enfmanipdate, s: episod },
      { f: enfmanipdate, s: death },
      { f: enfInsertionDate, s: enfmanipdate },

      { f: birthdate, s: intubStart },
      { f: intubStart, s: episod },
      { f: intubStart, s: death },
      { f: intubStart, s: intubEnd },
      { f: birthdate, s: intubEnd },
      { f: intubEnd, s: death }
    )
  }

  notes.compareDates(comparisons)
}

function buildNotes (result, sheet, year) {
  checkDates(result, sheet, year)
  common.checkPatientOrigin(result, sheet, year)
  checkBacteremia(result, sheet)
  checkNumericValues(result, sheet)
}

function buildNotesWithExplaur (result, sheet, year, surveillance) {
  buildNotes(result, sheet, year)

  common.checkBactMicroOrg(
    result, sheet, fields.episod, common.getExplaurUnit(sheet, surveillance)
  )
}

export default {
  build2019: function (result, sheet) {
    buildNotes(result, sheet, 2019)
    common.checkBactMicroOrg(result, sheet, fields.episod)
    return result
  },

  build2020: function (result, sheet) {
    buildNotes(result, sheet, 2020)
    common.checkBactMicroOrg(result, sheet, fields.episod)
    return result
  },

  build2021: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2021, surveillance)
    return result
  },

  build2022: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2022, surveillance)
    return result
  },

  build2023: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2023, surveillance)
    return result
  },

  build2024: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2024, surveillance)
    return result
  },

  build2025: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2025, surveillance)
    return result
  },

  build2026: function (result, sheet, surveillance) {
    buildNotesWithExplaur(result, sheet, 2026, surveillance)
    return result
  }
}
